import styles from "../index.css";
import { TRANSLATION_KEY_CAROUSEL_SR_TEXT } from "../constants";
import PropTypes from "prop-types";

export const ScreenReaderInstructions = ({ formatTranslation }) => (
  <span className={styles.screenreader}>
    <p>{formatTranslation(TRANSLATION_KEY_CAROUSEL_SR_TEXT)}</p>
  </span>
);

ScreenReaderInstructions.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
};
